import Types from "../actions/types";
import * as fromOrganisations from "features/organisations";
import { ofType } from "redux-observable";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { authHeaders, tokenExists, getOrganisationBaseUrl } from "frame";
import { onListRequestedSuccess, onListRequestedFailed } from "../actions";

const customerListEffect = (action$, state$) =>
	action$.pipe(
		ofType(
			Types.CUSTOMERS_LIST_REQUESTED,
			fromOrganisations.ORGANISATION_FETCH_SUCCESS,
			fromOrganisations.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED
		),
		filter(() => tokenExists()),
		filter(() => state$.value.organisations.currentOrganisation),
		filter(() => state$.value.queue.hasNetwork),
		mergeMap(() =>
			ajax
				.post(
					`${getOrganisationBaseUrl(state$.value)}/customer/paged`,
					{
						page: 1,
						pageSize: 5000,
						orderBy: "status,customerName",
						ascending: true,
					},
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onListRequestedSuccess(ajaxResponse.response))
					),
					catchError((error) => of(onListRequestedFailed(error)))
				)
		)
	);

export const customerPagedListEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.CUSTOMERS_PAGED_LIST_REQUESTED),
		filter(() => tokenExists()),
		filter(() => state$.value.organisations.currentOrganisation),
		filter(() => state$.value.queue.hasNetwork),
		mergeMap(({ payload }) => {
			const pagingParams = payload;

			return ajax
				.post(
					`${getOrganisationBaseUrl(state$.value)}/customer/paged`,
					pagingParams,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onListRequestedSuccess(ajaxResponse.response))
					),
					catchError((error) => of(onListRequestedFailed(error)))
				);
		})
	);

export default customerListEffect;
